<template>
	<!-- Ginny billetera -->
	<div class="function-app--about function-app--about__grey">
        <div class="container">
            <div class="row function-app-about-content">
                <div class="col function-app--about-img  d-flex">
                    <img
                        v-scroll="handleScroll"
                        data-scroll-class="animated slideInLeft"
                        data-scroll-once="true"
                        class="img-fluid fast"
                        alt="Vista de la Aplicación"
                        src="@/assets/images/sections/agregar-tarjeta.png">
                </div>
                <div
                    class="col function-app--about-list fast"
                    v-scroll="handleScroll"
                    data-scroll-once="true"
                    data-scroll-class="animated slideInUp">
                    <h2>¿Cómo agregar una tarjeta?</h2>
                    <p>
                        Agregar una tarjeta en la aplicación es muy sencillo, solo debes hacer clic en <b>Agregar Tarjeta +</b>
                        y completar la información requerida. Si aún tienes dudas puedes descargar nuestro PDF tutorial.
                    </p>

                    <a href='/ginny-como-agregar-tarjeta.pdf' target='_blank' class="btn btn-green btn-big"><i class="icon fas fa-download" /> Descargar Tutorial</a>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
	name: 'AboutSection'
};
</script>
<style lang="scss" scoped>
.function-app--about {
	overflow: hidden;

	h2,
	h5 {
		font-family: $primary-font;
		font-size: $large-font-size;
        color: $title-grey;
        margin-bottom: 1rem;

    }

    h5 {
        font-size: $medium-font-size;
        margin-top: 1.5rem;
    }

    p {
        font-size: $small-font-size;
        margin-bottom: 3rem;
    }

    .function-app--about-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: 400px;

        .btn-green {
            max-width: 270px;
        }
    }

	.function-app--about-img {
        overflow: hidden;
        justify-content: center;
    }

    &__grey {
        background-color: #FBFBFB;
    }
}
// Medium devices (desktops large, 1024px)
@media screen and (max-width: 1024px) {
	.function-app--about {
		.function-app--about-list h5,
		.sign-up-content h5 {
			font-size: $mobile-large-font-size;
		}

		.function-app--about-list ul li,
		.sign-up-content p {
			font-size: $mobile-extra-small-font-size;
		}
	}
}
// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
	.function-app--about-title {
        .about--section-title {
            padding: 0px 0 40px!important;
        }

		p {
			font-size: $mobile-small-font-size;
			margin-bottom: 0;
		}
	}

	.function-app--about {
		padding-bottom: 90px;
		.function-app--about-list {
			max-width: 80%;
            margin: 0 auto;
            padding: 0;

			h5 {
				margin: 10px 0;
                text-align: center;
                padding-left: 0;
			}

			ul li {
				font-size: $mobile-small-font-size;
			}
		}
	}

	.function--app-sign-up {
		display: flex;
		flex-direction: column;
		align-items: center;

		.sign-up-content {
			max-width: 100%;
			text-align: center;

			h5 {
				font-size: $medium-font-size;
			}

			p {
				font-size: $mobile-small-font-size;
			}
		}
		.input-group-sign-up {
			display: initial;
		}
    }

    .ahorro-notification {
        .ahorro-notification--content {
            padding: 50px 0 0px;
        }
    }

}
// Medium devices (tablet, 768px)
@media screen and (max-width: 768px) {
	.function-app--about {
		.function-app--about-list {
			max-width: 100%;
			justify-content: center;
			align-items: center;
        }

        .function-app--about-img {
            display: none!important;
        }
	}
}
// Medium devices (tablet, 600px)
@media screen and (max-width: 600px) {
	.function-app--about {
		.function-app--about-list {
			max-width: 100%;
        }

        .function-app--about-img {
            display: none !important;
        }
	}
}
// Medium devices (mobile, 480px)
@media screen and (max-width: 480px) {
	h1,
	h5 {
		font-size: $mobile-large-font-size;
	}
	.function-app--about {
		.function-app--about-title {
			font-size: $mobile-large-font-size;
		}

		.function-app--about-list {
			ul {
				li {
					line-height: 18px;
					margin-bottom: 15px;
				}
			}
		}

		.function--app-sign-up {
			width: 100%;
		}
	}
}
</style>